"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressPercentagePropType = exports.Kind = void 0;
var _GlobalKind = _interopRequireDefault(require("../type-tools/GlobalKind"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Kind = exports.Kind = function (Kind) {
  Kind[Kind["DEFAULT"] = _GlobalKind["default"].DEFAULT] = "DEFAULT";
  Kind[Kind["CRITICAL"] = _GlobalKind["default"].CRITICAL] = "CRITICAL";
  Kind[Kind["INVERSE"] = _GlobalKind["default"].INVERSE] = "INVERSE";
  return Kind;
}(Kind || {});
var ProgressPercentagePropType = exports.ProgressPercentagePropType = function ProgressPercentagePropType(minRange, maxRange) {
  return function (props, propName, componentName) {
    if (props[propName]) {
      var percentage = props.percentage;
      if (typeof percentage === 'number') {
        return percentage >= minRange && percentage <= maxRange ? null : new Error("<".concat(componentName, " /> ").concat(propName, " prop\n             \n Use a number between ").concat(minRange, " and ").concat(maxRange, " to render a determined spinner.\n             \n A number out of the range will render an undetermined spinner as fallback \n"));
      }
      return new Error("<".concat(componentName, " /> ").concat(propName, " prop\n       \n Determined spinner: use a number between ").concat(minRange, " and ").concat(maxRange, ".\n       \n Undetermined spinner: don't use ").concat(propName, "\n       \n Null or undefined value will render a undetermined spinner \n"));
    }
    return null;
  };
};